import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const drawerThemeToken: any = {
  //======================= COLOR ========================//
  colorBgElevated: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorIcon: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorIconHover: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorBgIcon: variableColors["ColorFigmaComplementaryBlue50"],
  colorBgMask: "rgba(45, 58, 76, 0.7)",
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorSplit: "transparent",

  //======================= SIZE ========================//
  padding: 24,
  paddingBlockHeader: 24,
  paddingBlockFooter: 24,
  paddingLG: 16,
  paddingXS: 16,
  fontSizeIcon: 16,
  fontSizeLG: parseInt(variableTypography["BodyH500FontSize"]),
  lineHeightLG: variableTypography["BodyH500LineHeight"],
  fontWeightStrong: "inherit",
  lineWidth: 0,
  marginXS: 0,

  //========================= FONT ========================//
  boxShadowDrawerDown: "none",
  boxShadowDrawerLeft: "none",
  boxShadowDrawerRight: "none",
  boxShadowDrawerUp: "none",
};
